module.exports = __webpack_public_path__ + "img/imgEmpty.1ffff451.png";